import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Select,
  Image,
  Table,
  Input,
  Modal,
  Flex,
} from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { notification } from "antd";
import { GreenNotify, RedNotify } from "../../helper/helper";
import UpdateStage from "../../components/updateStages/updateStages";
import Stage from "../../components/addStages/addStages";
import { homeIcon } from "../../assets";

const Organizers = () => {
  const [stages, setStages] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedStage, setSelectedStage] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [isUpdateModalVisible, setUpdateModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddStageModelVisible, setIsAddStageModelVisible] = useState(false);
  const [expandedText, setExpandedText] = useState(null);
  const [expandedModalVisible, setExpandedModalVisible] = useState(false);

  const getAllStages = () => {
    callApi("GET", routes.getStages, null, setIsLoading, (res) => {
      console.log("res", res);
      setStages(res?.data?.stages || []);
    });
  };

  useEffect(() => {
    getAllStages();
  }, []);

  const handleViewDetails = (record) => {
    setSelectedStage(record);
    setModalVisible(true);
  };

  const handleShowMore = (text) => {
    setExpandedText(text);
    setExpandedModalVisible(true);
  };

  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteStage}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setStages((prevStages) =>
            prevStages.filter((stage) => stage._id !== recordId)
          );
          GreenNotify("Stage Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting stage");
        }
      },
      (error) => {
        notification.error({
          message: "Error",
          description: "An error occurred while deleting the stage.",
        });
      }
    );
  };

  const handleAddStageModelClick = () => {
    setIsAddStageModelVisible(true);
  };

  const handleUpdate = (recordId) => {
    const selectedStage = stages.find((stage) => stage._id === recordId);
    setUpdateRecordData(selectedStage);
    setUpdateModalVisible(true);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Description",
      dataIndex: "description",
      className: "type-name-column-header",
      align: "center",
      render: (description) => (
        <div>
          <p>
            {description?.length > 50
              ? `${description?.slice(0, 30)}...`
              : description}
          </p>
          {description?.length > 50 && (
            <Button type="link" onClick={() => handleShowMore(description)}>
              Show More
            </Button>
          )}
        </div>
      ),
    },
    {
      title: "Distance(km)",
      dataIndex: "distance",
      align: "center",
    },
    {
      title: "Difficulty",
      dataIndex: "difficulty",
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleUpdate(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
          ></Button>
          <Button
            type="primary"
            icon={<InfoCircleOutlined />}
            onClick={() => handleViewDetails(record)}
          ></Button>
        </div>
      ),
    },
  ];

  const data = stages
    .map((item, index) => ({
      key: index,
      _id: item._id,
      title: item.title,
      description: item?.description,
      highLights: item.highLights,
      distance: Math.floor(item.distance),
      difficulty: item.difficulty,
    }))
    .filter((item) =>
      item?.title?.toLowerCase().includes(searchText.toLowerCase())
    );

  const getRowClassName = (record, index) =>
    index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";

  const handleCloseModal = () => {
    setExpandedText(null);
    setExpandedModalVisible(false);
    setModalVisible(false); // Ensure the info modal closes as well
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Stages</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Stages</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddStageModelClick}
        style={{ marginBottom: "16px" }}
      >
        Add Stage
      </Button>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        />
      </div>

      <UpdateStage
        visible={isUpdateModalVisible}
        toggleModal={() => {
          setUpdateModalVisible(false);
          getAllStages();
        }}
        onCancel={() => setUpdateModalVisible(false)}
        recordData={updateRecordData}
      />

      <Stage
        visible={isAddStageModelVisible}
        toggleModal={() => {
          setIsAddStageModelVisible(false);
          getAllStages();
        }}
      />

      <Modal
        title={
          <span
            className={
              modalVisible
                ? "blink-animation user-details-label"
                : "stage-details-label"
            }
          >
            Highlights👇
          </span>
        }
        visible={modalVisible}
        onCancel={handleCloseModal}
        footer={null}
        centered
      >
        {selectedStage && (
          <div style={{ padding: "20px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "24px",
                  marginBottom: "20px",
                }}
              >
                {selectedStage.title}
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {selectedStage.highLights.map((highlight, index) => (
                  <div
                    key={index}
                    style={{
                      borderRadius: "60px",
                      overflow: "hidden",
                      width: "120px",
                      height: "120px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Image
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "cover",
                        borderRadius: "60px",
                      }}
                      src={highlight}
                      alt={`highlight-${index}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </Modal>

      <Modal
        title="More Details"
        visible={expandedModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        centered
      >
        <p>{expandedText}</p>
      </Modal>
    </div>
  );
};

export default Organizers;
